import { z } from 'zod';
import { EmailSchema } from '../common/email.schema.js';
/**
 * User = a person who logs in. Formerly named Caller.
 *
 * A User:
 *   - has a single email (login identifier)
 *   - can be a super admin (Swoft staff) via `isSuperAdmin`
 *   - belongs to zero or more Organisations via Membership aggregates
 *     (not embedded here — fetched separately)
 *
 * The JWT only carries the active Membership (if any), not the full list.
 * The list is fetched once after login via GET /api/auth/memberships.
 */
export const UserSchema = z.object({
    id: z.string(),
    email: EmailSchema,
    username: z.string().min(1),
    fullName: z.string(),
    isSuperAdmin: z.boolean().default(false),
    isActive: z.boolean().default(true),
    twilioCallerId: z.string().default(''),
    dialerSettings: z.record(z.unknown()).default({}),
    coachingSystemPrompt: z.string().default(''),
    coachingContextDocs: z.string().default(''),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
/**
 * Shape accepted on POST /api/admin/users (super-admin only).
 * The super-admin creates the User AND the initial tenant_admin Membership
 * in a single transaction (see phase 1.5 §19.4).
 */
export const CreateUserInputSchema = z.object({
    email: EmailSchema,
    username: z.string().min(1),
    fullName: z.string().min(1),
    password: z.string().min(8),
    initialOrganisationId: z.string().optional(),
    initialRole: z.enum(['tenant_admin', 'caller', 'viewer']).optional(),
});
//# sourceMappingURL=user.schema.js.map